import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import { userFullName } from "util/user";
import Icon from "common/core/icon";

import Styles from "./card.module.scss";

type Props = {
  user: Parameters<typeof userFullName>[0] & {
    notaryProfile: null | { notaryId: string | null };
  };
  disabled?: boolean;
};

function CertificateCard({ user, disabled }: Props) {
  return (
    <div className={classNames(Styles.main, disabled && Styles.grayScale)}>
      <div className={Styles.title}>
        <Icon name="notary-proofing" />
        <FormattedMessage
          id="b713a15f-4cd9-4569-afef-9459d49a9025"
          defaultMessage="IAL2 Certified"
        />
      </div>
      <div className={Styles.name}>{userFullName(user)}</div>
      <div className={Styles.commissionNumber}>{user.notaryProfile?.notaryId}</div>
    </div>
  );
}

export default CertificateCard;
